export default __webpack_public_path__ + "static/media/img-0076-uk-premium-face.50b78930.png";